import { gql } from '@apollo/client';

const UPLOAD_AI_REPORT_MUTATION = gql`
  mutation uploadAiReport($input: UploadAiReportInput!) {
    uploadAiReport(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPLOAD_AI_REPORT_MUTATION;
